import React, { useEffect, useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { useProvince } from "@/contexts/ProvinceContext";
import api from "@/lib/api";
import { toast } from "sonner";
import { Link, Navigate } from "react-router-dom";

export default function Profile() {
  const { user, refreshUser, logout } = useAuth();
  const { provinces } = useProvince();
  const [f, setF] = useState({});
  const [pw, setPw] = useState({ current_password: "", new_password: "" });
  const [isColumnist, setIsColumnist] = useState(false);

  useEffect(() => {
    if (user) setF({ ...user });
    if (user) api.get("/columnists/me").then(() => setIsColumnist(true)).catch(() => setIsColumnist(false));
  }, [user?.id]);
  if (!user) return <Navigate to="/giris" replace />;

  const save = async () => {
    try { await api.put("/auth/me", f); await refreshUser(); toast.success("Güncellendi"); } catch { toast.error("Hata"); }
  };
  const changePw = async () => {
    try { await api.post("/auth/change-password", pw); toast.success("Şifre değiştirildi"); setPw({ current_password: "", new_password: "" }); } catch (e) { toast.error(e.response?.data?.detail || "Hata"); }
  };
  const delAcc = async () => {
    if (!window.confirm("Hesabınızı silmek istediğinizden emin misiniz?")) return;
    try { await api.delete("/auth/me"); toast.success("Hesap silme talebi alındı"); logout(); } catch { toast.error("Hata"); }
  };
  const kvkkReq = async () => {
    try { await api.post("/auth/kvkk-data-request"); toast.success("KVKK veri talebiniz alındı"); } catch { toast.error("Hata"); }
  };

  return (
    <div className="max-w-3xl mx-auto px-4 py-6">
      <h1 className="text-2xl md:text-3xl font-black mb-5">Profilim</h1>
      {isColumnist && (
        <div className="bg-gradient-to-r from-[#e11d2a]/10 to-[#e11d2a]/5 border border-[#e11d2a]/30 rounded-lg p-4 mb-4 flex items-center justify-between" data-testid="profile-columnist-banner">
          <div>
            <div className="text-xs uppercase font-bold text-[#e11d2a]">Köşe Yazarı</div>
            <div className="text-sm">Yazılarınızı ve profilinizi yönetin.</div>
          </div>
          <Link
            to="/kose-yazari"
            className="px-4 py-2 bg-[#e11d2a] text-white rounded text-sm font-semibold"
          >
            Yazar Paneli
          </Link>
        </div>
      )}
      <div className="bg-white border border-gray-100 rounded-lg p-6">
        <div className="grid md:grid-cols-2 gap-3">
          <FI label="Kullanıcı adı" value={f.username || ""} onChange={(v) => setF({ ...f, username: v })} />
          <FI label="Email" value={f.email || ""} disabled />
          <FI label="İsim" value={f.first_name || ""} onChange={(v) => setF({ ...f, first_name: v })} />
          <FI label="Soyisim" value={f.last_name || ""} onChange={(v) => setF({ ...f, last_name: v })} />
          <div>
            <label className="block text-sm font-medium mb-1">İl</label>
            <select value={f.province_id || ""} onChange={(e) => setF({ ...f, province_id: e.target.value })} className="w-full px-3 py-2 border border-gray-200 rounded-md text-sm">
              <option value="">Seçiniz</option>
              {provinces.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
            </select>
          </div>
          <FI label="İlçe" value={f.district || ""} onChange={(v) => setF({ ...f, district: v })} />
          <FI label="Telefon" value={f.phone || ""} onChange={(v) => setF({ ...f, phone: v })} />
          <FI label="Doğum tarihi" type="date" value={f.birth_date || ""} onChange={(v) => setF({ ...f, birth_date: v })} />
        </div>
        <div className="mt-4 flex gap-2"><button onClick={save} className="px-4 py-2 bg-[#e11d2a] text-white rounded-md text-sm font-semibold">Kaydet</button></div>
      </div>

      <h2 className="text-xl font-bold mt-8 mb-3">Şifre Değiştir</h2>
      <div className="bg-white border border-gray-100 rounded-lg p-6">
        <div className="grid md:grid-cols-2 gap-3">
          <FI label="Mevcut şifre" type="password" value={pw.current_password} onChange={(v) => setPw({ ...pw, current_password: v })} />
          <FI label="Yeni şifre" type="password" value={pw.new_password} onChange={(v) => setPw({ ...pw, new_password: v })} />
        </div>
        <button onClick={changePw} className="mt-3 px-4 py-2 bg-[#0b0b0d] text-white rounded-md text-sm">Şifreyi Güncelle</button>
      </div>

      <h2 className="text-xl font-bold mt-8 mb-3">Hesap İşlemleri</h2>
      <div className="bg-white border border-gray-100 rounded-lg p-6 flex gap-2 flex-wrap">
        <button onClick={kvkkReq} className="px-4 py-2 text-sm border border-gray-200 rounded-md">KVKK Verilerimi Talep Et</button>
        <button onClick={delAcc} className="px-4 py-2 text-sm bg-red-50 text-red-600 border border-red-200 rounded-md">Hesabımı Sil</button>
        <button onClick={logout} className="px-4 py-2 text-sm border border-gray-200 rounded-md">Oturumu Kapat</button>
      </div>
    </div>
  );
}

const FI = ({ label, value, onChange, ...rest }) => (
  <div>
    <label className="block text-sm font-medium mb-1">{label}</label>
    <input value={value || ""} onChange={(e) => onChange && onChange(e.target.value)} {...rest} className="w-full px-3 py-2 border border-gray-200 rounded-md text-sm" />
  </div>
);
